import { select } from 'redux-saga/effects';
import { getDefaultNotificationListRequest } from 'components/Tables/NotificationTable/notificationTableConstants';

export function* selectLastNotificationToListQuery() {
  const stored = yield select((state) => state.getIn(['notification', 'lastToListQuery']));
  return stored ? stored.toJS() : getDefaultNotificationListRequest();
}

export function* selectLastNotificationFromListQuery() {
  const stored = yield select((state) => state.getIn(['notification', 'lastFromListQuery']));
  return stored ? stored.toJS() : getDefaultNotificationListRequest();
}
